"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CoreTooltip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _CoreTooltipSt = require("./CoreTooltip.st.css");
var _CorePopover = require("../CorePopover");
var _FilterDataProps = require("../../utils/FilterDataProps");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/internal/WixUiCoreComponents/components/CoreTooltip/CoreTooltip.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Tooltip
 */
class CoreTooltip extends React.PureComponent {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      isOpen: false
    });
    (0, _defineProperty2.default)(this, "_handleClickOutside", () => {
      const {
        onClickOutside,
        shouldCloseOnClickOutside
      } = this.props;
      if (shouldCloseOnClickOutside) {
        this.props.onHide();
        this.setState({
          isOpen: false
        });
      }
      return onClickOutside ? onClickOutside() : null;
    });
    (0, _defineProperty2.default)(this, "_renderElement", () => {
      const {
        children,
        disabled,
        'aria-describedby': ariaDescribedBy
      } = this.props;
      if (typeof children === 'string' || !children) {
        return children || '';
      }
      return /*#__PURE__*/React.cloneElement(children, {
        onFocus: disabled ? undefined : this._onFocus,
        onBlur: disabled ? undefined : this._onBlur,
        'aria-describedby': ariaDescribedBy
      });
    });
    (0, _defineProperty2.default)(this, "open", () => {
      this.props.onShow();
      this.setState({
        isOpen: true
      });
    });
    (0, _defineProperty2.default)(this, "close", () => {
      const {
        shouldCloseOnClickOutside
      } = this.props;
      if (!shouldCloseOnClickOutside) {
        this.props.onHide();
        this.setState({
          isOpen: false
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onFocus", handlers => {
      const focusableHOC = handlers && handlers.focus;
      this.open();
      return focusableHOC ? handlers.focus() : null;
    });
    (0, _defineProperty2.default)(this, "_onBlur", handlers => {
      const focusableHOC = handlers && handlers.blur;
      this.close();
      return focusableHOC ? handlers.blur() : null;
    });
    (0, _defineProperty2.default)(this, "isShown", () => {
      const {
        disabled,
        shown
      } = this.props;
      if (shown) {
        return shown;
      }
      return disabled ? false : this.state.isOpen;
    });
  }
  render() {
    const {
      placement,
      content,
      moveBy,
      timeout,
      showArrow,
      moveArrowTo,
      appendTo,
      flip,
      fixed,
      hideDelay,
      showDelay,
      disabled,
      customArrow,
      zIndex,
      minWidth,
      maxWidth,
      'aria-describedby': ariaDescribedBy,
      className,
      contentClassName,
      disableClickOutsideWhenClosed,
      fluid
    } = this.props;
    return /*#__PURE__*/React.createElement(_CorePopover.CorePopover, (0, _extends2.default)({
      className: (0, _CoreTooltipSt.st)(_CoreTooltipSt.classes.root, className),
      placement: placement,
      shown: this.isShown(),
      showArrow: showArrow,
      onMouseEnter: disabled ? undefined : this.open,
      onMouseLeave: this.close,
      timeout: timeout,
      hideDelay: hideDelay,
      showDelay: showDelay,
      moveBy: moveBy,
      moveArrowTo: moveArrowTo,
      appendTo: appendTo,
      flip: flip,
      fixed: fixed,
      onClickOutside: this._handleClickOutside,
      customArrow: customArrow,
      id: ariaDescribedBy,
      role: "tooltip",
      zIndex: zIndex,
      minWidth: minWidth,
      maxWidth: maxWidth,
      contentClassName: contentClassName,
      disableClickOutsideWhenClosed: disableClickOutsideWhenClosed,
      fluid: fluid
    }, (0, _FilterDataProps.filterDataProps)(this.props), {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(_CorePopover.CorePopover.Element, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215,
        columnNumber: 9
      }
    }, this._renderElement()), /*#__PURE__*/React.createElement(_CorePopover.CorePopover.Content, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 216,
        columnNumber: 9
      }
    }, content));
  }
}
exports.CoreTooltip = CoreTooltip;
(0, _defineProperty2.default)(CoreTooltip, "displayName", 'CoreTooltip');
(0, _defineProperty2.default)(CoreTooltip, "defaultProps", {
  placement: 'top',
  appendTo: 'parent',
  onShow: () => ({}),
  onHide: () => ({}),
  timeout: 150,
  showDelay: 0,
  hideDelay: 0,
  showArrow: true
});
//# sourceMappingURL=CoreTooltip.js.map